export default __webpack_public_path__ + "static/media/bryan.08feee43.png";